<template>
  <div class="database" v-loading="loading">
    <el-button @click="goPage">返回</el-button>
    <el-date-picker
      v-model="timaValue"
      type="month"
      placeholder="选择月"
      value-format="timestamp"
      style="width: 300px; margin-right: 12px"
      clearable
      @change="timeChange"
    >
    </el-date-picker>
    <el-select
      v-model="value"
      placeholder="请选择销售人员"
      style="width: 300px; margin-right: 12px"
      filterable
      @change="changeFun"
    >
      <el-option label="不限" value></el-option>
      <el-option
        v-for="item in sale_options"
        :key="item.value"
        :label="item.realname"
        :value="item.staff_id"
      >
      </el-option>
    </el-select>
    <el-row>
      <el-col :span="12">
        <div
          id="chart1"
          style="width: 100%; height: 1000px; margin-top: 30px"
        ></div>
      </el-col>
      <el-col :span="12">
        <div
          id="chart2"
          style="width: 100%; height: 1000px; margin-top: 30px"
        ></div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <div
          id="chart3"
          style="width: 100%; height: 1200px; margin-top: 30px"
        ></div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { require } from "../utils/http_request";
export default {
  name: "database",
  //组件引入
  components: {},
  //状态存储
  data() {
    return {
      industry_data_lists: {},
      place_data_lists: {},
      product_data_lists: {},
      industry_data_list: [],
      place_data_list: [],
      product_data_list: [],
      sale_options: [],
      loading: true,
      timaValue: "",
      value: "",
      newTimeVlaue: "",
    };
  },
  //计算属性
  computed: {},
  //状态监听
  watch: {},
  //存放方法集合
  methods: {
    goPage() {
      this.$router.go(-1);
    },
    // 请求数据
    list() {
      var obj_data = {
        date_month: this.newTimeVlaue,
        sale_people_id: this.value,
      };
      this.loading = true;
      require("post", "/lufish_sale/v1/admin_deal_chart/", obj_data).then(
        (res) => {
          if (!res.code) {
            // nextTick会延迟加载内部的代码，等domxuanran完毕之后，会立即执行
            this.industry_data_lists = res.data.industry_data;
            this.place_data_lists = res.data.place_data;
            this.product_data_lists = res.data.product_data;
            // 如果在添加之前不重置内部数据,那这里面还有原来的数据,他会在把获取的数据push添加进去
            this.industry_data_list = [];
            this.place_data_list = [];
            this.product_data_list = [];
            this.lists();
            this.$nextTick(() => {
              this.industry_data_tu();
              this.place_data_list_tu();
              this.product_data_list_tu();
              this.loading = false;
            });
          }
        }
      );
    },
    // 展示数据
    lists() {
      for (const key in this.industry_data_lists) {
        this.industry_data_list.push({
          name: key,
          value: this.industry_data_lists[key],
        });
      }
      for (const key in this.place_data_lists) {
        this.place_data_list.push({
          name: key,
          value: this.place_data_lists[key],
        });
      }
      for (const key in this.product_data_lists) {
        this.product_data_list.push({
          name: key,
          value: this.product_data_lists[key],
        });
      }
    },
    // 公司显示
    sale_options_list() {
      require("post", "/lufish_sale/v1/all_agent_list/", {}).then((res) => {
        console.log(res);
        if (res.code == 0) {
          this.sale_options = res.data;
        }
      });
    },
    // 公司选中后触发
    changeFun() {
      this.list();
    },
    // 时间选中
    timeChange(e) {
      // e是获取的时间戳,然后给后台秒除以1000
      this.newTimeVlaue = Number(e / 1000);
      if (!e) {
        this.newTimeVlaue = "";
      }
      this.list();
    },
    // 可以一个方法写完,方法传参,但是没必要这个页面东西少,一个一个写就行
    industry_data_tu() {
      var chartDom = document.getElementById("chart1");
      var myChart = this.$echarts.init(chartDom);
      myChart.setOption({
        title: {
          text: "职位数量统计",
          left: "left",
        },
        tooltip: {
          trigger: "item",
          // a是series.name,b是this.industry_data_list里面的name值，c是this.industry_data_list里面的value，d是百分比
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        },
        series: [
          {
            name: "职业",
            type: "pie",
            radius: "55%",
            center: ["50%", "50%"],
            data: this.industry_data_list,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      });
    },
    place_data_list_tu() {
      var chartDom = document.getElementById("chart2");
      var myChart = this.$echarts.init(chartDom);
      myChart.setOption({
        title: {
          text: "城市数量统计",
          left: "left",
        },
        tooltip: {
          trigger: "item",
          // a是series.name,b是this.industry_data_list里面的name值，c是this.industry_data_list里面的value，d是百分比
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        },
        series: [
          {
            name: "城市",
            type: "pie",
            radius: "55%",
            center: ["50%", "50%"],
            data: this.place_data_list,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      });
    },
    product_data_list_tu() {
      var chartDom = document.getElementById("chart3");
      var myChart = this.$echarts.init(chartDom);
      myChart.setOption({
        title: {
          text: "版本数量统计",
          left: "left",
        },
        tooltip: {
          trigger: "item",
          // a是series.name,b是this.industry_data_list里面的name值，c是this.industry_data_list里面的value，d是百分比
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        },
        series: [
          {
            name: "版本",
            type: "pie",
            radius: "55%",
            center: ["50%", "50%"],
            data: this.product_data_list,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      });
    },
  },
  //数据初始化之后
  created() {
    this.sale_options_list();
    this.value = "";
    this.timaValue = "";
    this.newTimeVlaue = "";
    this.list();
  },
  //页面渲染之后
  mounted() {},
  //数据初始化之前
  beforeCreate() {},
  //页面渲染之前
  beforeMount() {},
  //状态更新之前
  beforeUpdate() {},
  //状态更新之后
  updated() {},
  //页面卸载之前
  beforeDestroy() {},
  //卸载之后
  destroyed() {},
  //页面进入   页面缓存时有效
  activated() {},
};
</script>
<style  scoped>
.database {
  position: relative;
  width: calc(100% - 209px);
  left: 181px;
  top: 68px;
  padding: 14px;
}
</style>



// WEBPACK FOOTER //
// src/sales_management/database.vue